module.exports = __webpack_public_path__ + "assets/img/6c39-np.svg";